import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from '../../../services/general.service';
import { UsersService } from '../../../services/users.service';
import { ProvidersService } from '../../../services/providers.service';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
  userId: any;
  userToken: any;
  textButton: any;
  loadBtn = false;
  type: any;
  user: any = {};
  newPass: any = {};
  listProfiles: any;
  listProviders: any;
  editId: any;
  showProviders = false;
  username: any;

  constructor(private toastr: ToastrService, private provService: ProvidersService, private gralService: GeneralService, private usersService: UsersService, public dialogRef: MatDialogRef<UserComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.type = this.data.type;
    this.userToken = this.data.userToken;
    this.listProfiles = this.data.profiles;
    this.editId = this.data.id;
    this.listProviders = this.data.providers;
    console.log(this.listProviders);

    
    if(this.type === 'add'){
      this.textButton = 'ADDUSER';
    }

    if(this.type === 'edit'){
      this.user = this.data.info;
      this.textButton = 'EDITUSER';
    }

    if(this.type === 'password'){
      this.newPass.Usuario = this.data.username;
      this.textButton = 'ACTIONS.CHANGEPASSWORD';
    }

    console.log("this.user %o", this.user);
  }

  ngOnInit() {
  }

  selectProfile(){
    if(this.user.IdPerfil == 3){
      this.showProviders = true;
    }
  }

  getProviders(){
    this.provService.getProvidersActive(this.userId, this.userToken).then((data) => {
      this.listProviders = data['msg'];
      this.showProviders = true;
    }, (err) => {
      console.log(err);
      this.toastr.error(err['error'].msg, 'Error al cargar lista de proveedores');
      this.listProviders = null;
    });
  }

  onCloseConfirm() {
    if(this.type == 'password'){
      if(!this.newPass.NuevoPassword){
        this.toastr.error('Favor de agregar la nueva contraseña', 'Error');
        return false;
      }

      this.loadBtn = true;
      this.usersService.changePasswordUser(this.editId, this.newPass, this.userToken).then((data) => {
        this.loadBtn = false;
        if(data['EsValido']){
          this.toastr.success('Contraseña modificada correctamente', 'Cambiar contraseña');
          this.dialogRef.close();
        }else{
          this.toastr.error(data['MensajeUsuario'], 'Cambiar contraseña');
          return;
        }
      }, (err) => {
        this.loadBtn = false;
        console.log(err);
        this.toastr.error(err['error'].msg, 'Error al agregar');
        if(err.status == 401){
          this.gralService.actDeacUser(false);
        }
      });
    }else{
      if(!this.user.Nombre || !this.user.Apellidos || !this.user.Email || !this.user.Usuario || !this.user.IdPerfil){// || ((this.user.profile == 'provider_sub' && !this.user.provider) || (this.user.profile == 'provider' && !this.user.provider))){
        this.toastr.error('Favor de agregar todos los campos obligatorios', 'Error');
        return false;
      }

      // validar email

      this.loadBtn = true;
      if(this.type == 'add'){
        if(!this.user.Password){
          this.toastr.error('Favor de agregar todos los campos obligatorios', 'Error');
          this.loadBtn = false;
          return false;
        }

        this.usersService.newUser(this.user, this.userToken).then((data) => {
          this.loadBtn = false;
          if(data['EsValido']){
            this.dialogRef.close({ data: data['Entidad'] });
          }else{
            this.toastr.error(data['MensajeUsuario'], 'Error al agregar');
            return;
          }
        }, (err) => {
          this.loadBtn = false;
          console.log(err);
          this.toastr.error(err['error'].msg, 'Error al agregar');
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }

      if(this.type == 'edit'){
        this.usersService.updateUser(this.editId, this.user, this.userToken).then((data) => {
          this.loadBtn = false;
          if(data['EsValido']){
            this.dialogRef.close({ data: data['Entidad'] });
          }else{
            this.toastr.error(data['MensajeUsuario'], 'Error al editar');
            return;
          }
        }, (err) => {
          this.loadBtn = false;
          console.log(err);
          this.toastr.error(err['error'].msg, 'Error al editar');
          if(err.status == 401){
            this.gralService.actDeacUser(false);
          }
        });
      }
    }
  }

  onCloseCancel() {
    this.dialogRef.close();
  }
}
